import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './style.scss';
const FullModal = (props) => {
  const node = document.createElement('div');
  node.className = 'FullModelBox';
  document.body.appendChild(node);
  useEffect(() => {
    document.documentElement.style.overflow = 'hidden';
    return () => {
      document.body.removeChild(node);
      Array.from(document.getElementsByClassName('FullModelBox')).forEach((element) => element.remove());
      document.documentElement.style.overflow = 'auto';
      document.documentElement.style.overflowX = 'hidden';
    };
  }, []);
  return createPortal(
    <div className="FullModel">
      <div className="FullModelContent">{props.children}</div>
    </div>,
    node
  );
};
export default FullModal;
